import { getMbis } from "@/services";
import { useQuery } from "react-query";

export const useGetMbisData = () => {
 const { data: mbis, isLoading: getMbisIsLoading } = useQuery("mbis", getMbis);
 return { mbis, getMbisIsLoading };
};
